import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import R from 'ramda';
import { RaisedButton, Paper, TextField, Checkbox, FlatButton } from 'material-ui';
import SignSuccess from './signigng-success';
import TemplateListForRC, { getStatus } from '../../contracting/dummy-account/template-list-for-RC';
import { SmallFlatButton } from '../../tc-ui/small-buttons';
import RateDocIframe from '../../contracting/dummy-account/rate-doc-iframe';

class Signing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signatureText: '',
      termsChecked: false,
      message: '',
      showOtherDocs: false,
      checkedMap: this.getCheckedMap(props, {}),
    };
  }
  componentWillReceiveProps(nextProps) {
    if (
      R.path(['dummySupplierForCR', 'templates', 'length'], nextProps)
      && !R.path(['dummySupplierForCR', 'templates', 'length'], this.props)
    ) this.setState({ checkedMap: this.getCheckedMap(nextProps, this.state.checkedMap) });
  }

  onCheck = (checked, rateDocId) => this.setState({
    checkedMap: {
      ...this.state.checkedMap,
      [rateDocId]: {
        ...this.state.checkedMap[rateDocId],
        checked,
      },
    },
  });
  getCheckedMap = ({ dummySupplierForCR: { templates }, rateDocIds }, start) => {
    return templates.reduce((ret, o) => {
      if (rateDocIds.indexOf(o._id) > -1 || rateDocIds.indexOf(o.originalContractId) > -1) {
        if (getStatus(o) !== 'Signed') ret[o._id] = { checked: true };
        else ret[o._id] = { checked: false };
      } else ret[o._id] = { checked: false };
      return ret;
    }, start || {});
  };
  sign = docsToSign => () => {
    const {
      contractId: crId,
      email,
      signRateDocs,
    } = this.props;
    const someReviewed = docsToSign.some(template => template.acceptedBy.indexOf(email) > -1);
    let confirm = docsToSign.every(template => template.acceptedBy.indexOf(email) > -1);
    if (!confirm) {
      confirm = window.confirm(`You haven't reviewed ${someReviewed ? `some of ` : ''}your rates yet. Are you sure you'd like to continue?`);
    }
    if (confirm) {
      const {
        signatureText,
        message,
      } = this.state;
      signRateDocs({
        crId,
        rateDocIds: docsToSign.map(obj => obj.originalContractId || obj._id),
        signatureText,
        message,
        signedBy: email,
      });
    }
  };
  render() {
    const {
      dummySupplierForCR: {
        templates = [],
      },
      contractId: crId,
      to,
      from,
      email,
      signing,
      successfullySigned,
      openSignUp,
      requestSigsChecked,
      rateDocIds,
      reloadRequest,
      markDummyTemplateAsViewed,
      createdContracts,
      downloadRates,
    } = this.props;
    const downloadRatesAfterSigningSuccess = () => {
      downloadRates({
        contractIds: createdContracts.map(o => o._id),
        collection: 'contract',
        isBulk: true,
        forAL: true,
      });
    };
    const {
      signatureText,
      termsChecked,
      message,
      showOtherDocs,
      checkedMap,
    } = this.state;
    const otherDocs = [];
    const docsToShow = [];
    const docsToSign = [];
    templates.forEach(o => {
      if (checkedMap[o._id] && checkedMap[o._id].checked) docsToSign.push(o);
      if (rateDocIds.indexOf(o._id) > -1 || rateDocIds.indexOf(o.originalContractId) > -1) {
        docsToShow.push(o);
      } else otherDocs.push(o);
    });
    const {
      disableSignButton,
      errorText,
    } = (() => {
      if (!docsToSign.length) {
        return {
          disableSignButton: true,
          errorText: 'Please select at least one rate sheet to submit.',
        };
      }
      if (requestSigsChecked) {
        if (!signatureText.trim()) {
          return {
            disableSignButton: true,
            errorText: 'Signature is required.',
          };
        }
        if (!termsChecked) {
          return {
            disableSignButton: true,
            errorText: 'Please check the terms.',
          };
        }
      }
      if (docsToSign.some(o => getStatus(o) !== '100% completed')) {
        return {
          disableSignButton: true,
          errorText: (
            <span>
              {docsToSign.length > 1 ? 'All rate sheets' : 'The rate sheet'} must be 100% complete. &nbsp;&nbsp;
              <a onClick={() => reloadRequest({ crId })}>Refresh</a>
            </span>
          ),
        };
      }
      return {
        disableSignButton: signing,
        errorText: '',
      };
    })();
    if (successfullySigned) {
      return (
        <div style={{ textAlign: 'center' }}>
          <SignSuccess
            signUp={openSignUp}
            createdContracts={createdContracts}
            downloadRatesAfterSigningSuccess={downloadRatesAfterSigningSuccess}
          />
        </div>
      );
    }
    if (!docsToShow.length) {
      return (
        <div style={{ marginTop: '2em' }}>
          <b>This rate sheet has been signed by someone else.</b>
        </div>
      );
    }
    const inSigning = {
      checkedMap,
      onCheckFunc: this.onCheck,
      onClickFunc: rateDocId => markDummyTemplateAsViewed({ rateDocId }),
      buyerLogo: from.avatar,
      buyerName: from.name,
    };
    return (
      <div style={{ width: '900px', marginTop: '2em' }}>
        <label>Please review the rates that we loaded for {to.name}. Once you've finished, you can submit your rates from this page below.</label>
        <br/>
        <br/>
        <Paper style={{ padding: '16px' }}>
          <TemplateListForRC
            title="RATE SHEETS TO SUBMIT"
            templates={docsToShow}
            inSigning={inSigning}
          />
        </Paper>
        {
          Boolean(otherDocs.length && !showOtherDocs) && (
            <FlatButton
              label={`Show ${otherDocs.length === 1 ? 'Another Sheet' : `${otherDocs.length} Other Sheets`} We Are Loading`}
              style={{ border: '1px solid #00bcd4', marginTop: '16px', borderRadius: '20px' }}
              secondary
              onClick={() => {
                this.setState({ showOtherDocs: true });
              }}
            />
          )
        }
        {
          showOtherDocs && (
            <Paper style={{ padding: '16px', marginTop: '1em', position: 'relative' }}>
              <SmallFlatButton
                label="Hide"
                style={{ top: '16px', right: '20px', position: 'absolute' }}
                secondary
                onClick={() => this.setState({ showOtherDocs: false })}
              />
              <TemplateListForRC
                title="OTHER RATE SHEETS"
                templates={otherDocs}
                inSigning={inSigning}
              />
            </Paper>
          )
        }
        {
          docsToShow.every(t => getStatus(t) === 'Signed')
          ? (
              <div style={{ marginTop: '2em' }}>
                <b>{docsToShow.length > 1 ? 'These rate sheets' : 'This rate sheet'} has been signed by someone else.</b>
              </div>
            )
          : (
              <Paper style={{ padding: '1em', marginTop: '1em' }}>
                <label style={{ fontSize: '16px', fontWeight: 'bold' }}>Submit & Sign</label>
                <div
                  style={{
                    padding: '8px 12px',
                    overflow: 'auto',
                    minHeight: '100px',
                    border: '1px solid #00BCD4',
                    borderRadius: '3px',
                    width: '100%',
                    backgroundColor: '#fff',
                    margin: '1em auto 2em',
                  }}
                >
                  <TextField
                    id="messagebox"
                    hintStyle={{ fontSize: '14px' }}
                    hintText="Optional message text to be sent with your signature..."
                    underlineShow={false}
                    style={{ width: 'calc(100% - 24px)' }}
                    value={message}
                    onChange={e => this.setState({ message: e.target.value })}
                    multiLine
                    rowsMax={8}
                  />
                </div>
                <div style={{ margin: '2em' }}>
                  <div className="flex-center" style={{ marginBottom: '1em' }}>
                    <b style={{ width: '30%', textAlign: 'left' }}>Signature</b>
                    <input
                      style={{ border: '1px solid #e0e0e0', width: '70%', borderRadius: '2px', padding: '2px' }}
                      placeholder="Enter your full name here..."
                      value={signatureText}
                      onChange={e => this.setState({ signatureText: e.target.value })}
                    />
                  </div>
                  <div className="flex-center" style={{ marginBottom: '1em' }}>
                    <b style={{ width: '30%', textAlign: 'left' }}>DateSigned</b>
                    <span>
                      {moment().format('DD/MM/YYYY')}
                    </span>
                  </div>
                  <div className="flex-center" style={{ marginBottom: '1em' }}>
                    <b style={{ width: '30%', textAlign: 'left' }}>Email</b>
                    <span>{email}</span>
                  </div>
                  <Checkbox
                    checked={termsChecked}
                    onCheck={(_, checked) => this.setState({ termsChecked: checked })}
                    label={<small>By ticking this box you are signing this contract to be used by {from.name}. You are taking full responsibility for the rates loaded and {from.name} or other partner is NOT liable for these errors.</small>}
                  />
                </div>
                <RaisedButton
                  disabled={disableSignButton}
                  label={docsToSign.length === 1 ? 'Submit' : `Submit All Documents`}
                  onClick={this.sign(docsToSign)}
                  secondary
                />
                {
                  Boolean(errorText) && (
                    <label style={{ color: '#ff4081', display: 'block' }}>
                      {errorText}
                    </label>
                  )
                }
              </Paper>
            )
        }
        <RateDocIframe/>
      </div>
    );
  }
}

Signing.propTypes = {
  contractId: PropTypes.string,
  dummySupplierForCR: PropTypes.object,
  email: PropTypes.string,
  from: PropTypes.object,
  to: PropTypes.object,
  signRateDocs: PropTypes.func,
  openSignUp: PropTypes.func,
  successfullySigned: PropTypes.bool,
  signing: PropTypes.bool,
  requestSigsChecked: PropTypes.bool,
  rateDocIds: PropTypes.array,
  reloadRequest: PropTypes.func,
  markDummyTemplateAsViewed: PropTypes.func,
  downloadRates: PropTypes.func,
  createdContracts: PropTypes.array,
};

const mapState = ({ assetsLandingReducer }) => ({
  ...assetsLandingReducer.request,
  requestSigsChecked: assetsLandingReducer.requestSigsChecked,
  rateDocIds: assetsLandingReducer.rateDocIds,
  email: assetsLandingReducer.email,
});
export default connect(mapState, {
  signRateDocs: payload => ({ type: '[asset-landing]SIGN_RATE_DOCS', payload }),
  reloadRequest: payload => ({ type: '[asset-landing] RELOAD_CONTRACT_REQUEST', payload }),
  markDummyTemplateAsViewed: payload => ({ type: '[asset-landing] MARK_DUMMY_TEMPLATE_AS_VIEWED', payload }),
  downloadRates: payload => ({ type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER', payload }),
})(Signing);



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/request/signing.jsx